<template>
  <v-modal x-short @close="$emit('close')">
    <template slot="#thread-renaming">
      <div class="thread-renaming__container d-flex flex-column">
        <action-header v-if="!isRenamedSuccessfully">
          {{ $t("components.modals.threadRenameModal.renameGroup") }}
        </action-header>
        <action-body>
          <div v-if="isRenamedSuccessfully">
            <div class="p-2 container text-center">
              <v-icon
                class="mt-2"
                icon="done_all"
                size="3rem"
                color="var(--brand-color-hex)"
              />
              <h2 class="mb-0">
                {{ $t("components.modals.threadRenameModal.groupRenamed") }}
              </h2>
              <p class="text-grey-70 mt-2 font-weight-semi-bold">
                {{ $t("components.modals.threadRenameModal.renameGroupSuccess") }}
              </p>
            </div>
          </div>
          <div v-else>
            <div class="m-2">
              <v-input
                v-model="title"
                autofocus
                :placeholder="$t('components.modals.threadRenameModal.updateGroupName')"
              />
            </div>
          </div>
        </action-body>
        <action-footer classes="w-100">
          <v-button
            v-if="isRenamedSuccessfully"
            primary
            block
            @click="handleCloseCompletely"
          >
            {{ $t("components.modals.threadRenameModal.closeBtn") }}
          </v-button>
          <v-button
            v-else
            primary
            block
            :disabled="isEmpty(title)"
            :is-loading="isLoading"
            @click="handleRenameThread"
          >
            {{ $t("components.modals.threadRenameModal.saveBtn") }}
          </v-button>
        </action-footer>
      </div>
    </template>
  </v-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import { isEmpty } from "@/lib/utils"

import vInput from "@/components/forms/vInput"
import ActionHeader from "@/components/modals/shared/ActionHeader"
import ActionBody from "@/components/modals/shared/ActionBody"
import ActionFooter from "@/components/modals/shared/ActionFooter"

export default {
  components: {
    vInput,
    ActionHeader,
    ActionBody,
    ActionFooter
  },

  props: {
    messageThread: { type: Object, required: true }
  },

  data() {
    return {
      isLoading: false,
      isRenamedSuccessfully: false,
      title: this.messageThread.title
    }
  },

  computed: {
    ...mapGetters("auth", ["isAuthenticated", "currentUser"]),

    isAdmin() {
      return this.isAuthenticated && this.currentUser?.isAccountAdmin
    }
  },

  methods: {
    isEmpty,
    ...mapActions("messages", ["renameThread"]),

    handleRenameThread() {
      if (!this.isAdmin) return

      this.isLoading = true

      this.renameThread({
        messageThreadId: this.messageThread.id,
        title: this.title
      })
        .then(() => {
          this.isRenamedSuccessfully = true
        })
        .catch(() => {
          this.$notify(this.$t("components.modals.threadRenameModal.errorMessage"))
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    handleCloseCompletely() {
      this.$emit("close", false)
    }
  }
}
</script>
